import React from 'react';
import { Play } from 'lucide-react';
import { useDetail } from '../context/DetailContext';

const FreeMovieCard = ({ movie }) => {
  const { openFree } = useDetail();
  return (
    <button
      data-testid={`free-movie-card-${movie.id}`}
      onClick={() => openFree(movie)}
      className="tv-focusable group relative flex-shrink-0 w-[200px] h-[300px] rounded-xl overflow-hidden bg-white/5 card-shine text-left"
    >
      <img src={movie.thumbnail} alt={movie.title} loading="lazy" className="w-full h-full object-cover" />
      <span className="absolute top-2 left-2 px-2 py-0.5 rounded-md text-[9px] font-bold tracking-widest bg-emerald-500 text-black">FREE MOVIE</span>
      <div className="absolute inset-0 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity duration-200 bg-black/40">
        <Play size={36} className="text-white fill-white" />
      </div>
      <div className="absolute inset-x-0 bottom-0 p-3 bg-gradient-to-t from-black/95 via-black/50 to-transparent">
        <div className="text-[11px] text-white/75 mb-1">{movie.year} {movie.duration_sec ? `• ${Math.round(movie.duration_sec / 60)} min` : ''}</div>
        <div className="text-[13px] font-semibold line-clamp-2 text-white">{movie.title}</div>
      </div>
    </button>
  );
};

export default FreeMovieCard;
